export const es = {
    share: {
        loading: 'Cargando foto compartida...',
        unavailableTitle: 'Enlace no disponible',
        unavailableMessage: 'Este enlace ya no está disponible. Puede que su propietario lo haya eliminado.',
        tagged: 'Etiquetado como',
    },
    header: {
        title: 'Momentos en Familia',
        toggleFilters: 'Alternar filtros',
        upload: 'Subir fotos',
        lightMode: 'Cambiar a modo claro',
        darkMode: 'Cambiar a modo oscuro',
        moreOptions: 'Más opciones',
        settings: 'Configuración',
        logout: 'Cerrar sesión',
    },
    dashboard: {
        loadingMemories: 'Cargando tus recuerdos...',
        noPhotos: 'Sin fotos aún. ¡Sube tu primer recuerdo!',
        noPhotosFiltered: 'Ninguna foto coincide con tus filtros.',
        toggleThemeLight: 'Modo Claro',
        toggleThemeDark: 'Modo Oscuro',
        user: 'Usuario',
    },
    sidebar: {
        people: 'Personas',
        noPeopleTagged: 'Sin personas etiquetadas',
        places: 'Lugares',
        noPlacesTagged: 'Sin lugares etiquetados',
        years: 'Años',
        noYearsTagged: 'Sin años etiquetados',
        events: 'Eventos',
        noEventsTagged: 'Sin eventos etiquetados',
        visibility: 'Visibilidad',
        all: 'Todo',
        public: 'Público',
        private: 'Privado',
        resetAllFilters: 'Restablecer todos los filtros',
        resetIcon: 'Restablecer todos los filtros',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        searchPlaceholder: 'Buscar etiquetas...',
        noMatchesFound: 'Sin resultados',
    },
    dock: {
        all: 'Todo',
        clear: 'Limpiar',
        clearAllFilters: 'Limpiar todos los filtros',
        allPhotos: 'Todas las fotos',
        loading: 'Cargando...',
    },
    settings: {
        title: 'Configuración',
        theme: 'Tema',
        light: 'Claro',
        dark: 'Oscuro',
        language: 'Idioma',
    },
    upload: {
        title: 'Subir fotos',
        dragDropText: 'Arrastra y suelta fotos aquí o haz clic para seleccionar',
        fileTypes: 'JPG, PNG, WebP (hasta 50 MB cada una)',
        cancel: 'Cancelar',
        uploadAll: 'Subir todo',
        uploading: 'Subiendo...',
        errorPrefix: 'Error: ',
    },
    photoModal: {
        closeSettings: 'Cerrar configuración',
        rating: 'Calificación',
        tagged: 'Etiquetado como',
        visibility: 'Visibilidad',
        visibilityPublic: 'Público',
        visibilityPrivate: 'Privado',
        manageSection: 'Gestionar',
        makePublic: 'Hacer Público',
        makePrivate: 'Hacer Privado',
        deletePhoto: 'Eliminar Foto',
        deletePhotoConfirmTitle: 'Eliminar Foto',
        deletePhotoConfirmMessage: 'Esta acción no se puede deshacer. ¿Estás seguro de que deseas eliminar esta foto?',
        restoreOriginal: 'Restaurar Original',
        restoreOriginalConfirmTitle: 'Restaurar Original',
        restoreOriginalConfirmMessage: 'Esto reemplazará la foto actual con su respaldo previo a la mejora, deshaciendo la última mejora. ¿Continuar?',
        deleteBackup: 'Eliminar Respaldo',
        deleteBackupConfirmTitle: 'Eliminar Respaldo',
        deleteBackupConfirmMessage: 'Esto elimina permanentemente el respaldo previo a la mejora. La foto actual (mejorada) no se verá afectada, y esto no se puede deshacer. ¿Continuar?',
        hardDeletePhoto: 'Eliminar Permanentemente',
        hardDeletePhotoConfirmTitle: 'Eliminar Foto Permanentemente',
        hardDeletePhotoConfirmMessage: 'Esto elimina permanentemente la foto y todos los archivos que le pertenecen del almacenamiento, incluyendo cualquier respaldo. Esto no se puede deshacer. ¿Continuar?',
        generatePublicLink: 'Generar Enlace Público',
        copyPublicLink: 'Copiar Enlace',
        removePublicLink: 'Eliminar Enlace',
        publicLinkCopied: '¡Enlace copiado!',
    },
    login: {
        logIn: 'Ingresar',
        invalid: '¡Inválido!!',
    },
    changeAccessCode: {
        forcedHeading: 'Debes actualizar tu código de acceso antes de continuar',
        voluntaryHeading: 'Cambiar tu código de acceso',
        currentPinLabel: 'Ingresa tu código de acceso actual',
        newPinLabel: 'Ingresa tu nuevo código de acceso',
        confirmPinLabel: 'Confirma tu nuevo código de acceso',
        continueButton: 'Continuar',
        confirmButton: 'Confirmar',
        saving: 'Guardando...',
        minDigitsError: 'Ingresa al menos 4 dígitos.',
        mismatchError: 'Los códigos no coinciden. Intenta de nuevo.',
        invalidCurrentPin: 'Tu código actual es incorrecto.',
        invalidNewPin: 'El nuevo código debe tener 4-10 dígitos y ser diferente al actual.',
        genericError: 'Algo salió mal. Intenta de nuevo.',
    },
    common: {
        loading: 'Cargando...',
        error: 'Error',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
    },
};
